import { toCurrency } from "../../../../helpers";
import { Box, Container, Table, Td, Th, Tr } from "./styles";

function Pefin({ data }) {
  return (
    <>
      {data?.pefin && (
        <Container>
          <Box>
          <h3 style={{fontSize: 14}}>Dívidas em outros seguimentos</h3>
          <h4>Pefin - Até 5 ocorrencias mais recentes</h4>
          <Table>
            <Tr>
              <Th>Data</Th>
              <Th>Modalidade</Th>
              <Th>Avalista</Th>
              <Th>Valor</Th>
              <Th>Contrato</Th>
              <Th>Origem</Th>
              <Th>Local</Th>
            </Tr>
            {data?.pefin?.occurrences.map((item) => {
              return (
                <tr>
                  <Td>{item.date}</Td>
                  <Td>{item.title}</Td>
                  <Td>{item.isGuarantor ? "Sim" : "Não"}</Td>
                  <Td>{toCurrency(item.value)}</Td>
                  <Td>{item.contract}</Td>
                  <Td>{item.origin}</Td>
                  <Td>{item.subJudiceDistrict}</Td>
                </tr>
              );
            })}
          </Table>
      </Box>
    </Container>
      )}
      </>
  );
}

export default Pefin;
